module.exports = function() {
  return new Worker(__webpack_public_path__ + "205b2d8c020ea1935d37.worker.js");
};